import { onMounted, onUnmounted } from 'vue'
import { useAnalytics } from './useAnalytics'

export function useScrollTracking() {
  const analytics = useAnalytics()
  let scrollTimeout: number | null = null
  let maxScrollDepth = 0

  const trackScrollDepth = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const scrollPercent = Math.round((scrollTop / docHeight) * 100)
    
    // Track scroll depth milestones (25%, 50%, 75%, 100%)
    const milestones = [25, 50, 75, 100]
    milestones.forEach(milestone => {
      if (scrollPercent >= milestone && maxScrollDepth < milestone) {
        maxScrollDepth = milestone
        analytics.trackEvent({
          action: 'scroll_depth',
          category: 'engagement',
          label: `${milestone}%`,
          value: milestone
        })
      }
    })
  }

  const debouncedTrackScroll = () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
    scrollTimeout = window.setTimeout(trackScrollDepth, 100)
  }

  onMounted(() => {
    window.addEventListener('scroll', debouncedTrackScroll, { passive: true })
  })

  onUnmounted(() => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
    window.removeEventListener('scroll', debouncedTrackScroll)
  })

  return {
    trackScrollDepth
  }
} 